import React from 'react'
import CopyToClipboard from '../../../../utils/copy-to-clipboard'

const InvoiceId = ({ value }) => {
  return <CopyToClipboard text={value}>{value}</CopyToClipboard>
}
export default InvoiceId
